import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import qaData from '../data/qaData'; // Your existing external data
import '../App.css';
import heroImg from '../assets/faqcover.png';
import LiveChat from '../components/LiveChat';
import QAChatbot from '../components/QAChatBot';
import GetQuoteButton from '../components/GetQuoteButton';
import ScrollSocialIcons from '../components/ScrollSocialIcons';
import BackToTopButton from '../components/BackToTopButton';

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    // Expanded FAQ Data specifically for CIAP
    const ciapSpecificQA = [
        {
            question: "What core marine engineering services does CIAP provide?",
            answer: "CIAP specializes in a wide range of services including mechanical servicing, ship maintenance, marine refrigeration systems, offshore equipment support, and specialized repairs for automated marine systems such as PLCs, DCS, and SCADA."
        },
        {
            question: "Does CIAP offer 24/7 emergency afloat repairs?",
            answer: "Yes, we understand the critical nature of maritime operations. CIAP provides rapid-response technical teams for emergency afloat repairs to minimize vessel downtime in both port and offshore locations."
        },
        {
            question: "What regions does CIAP currently serve?",
            answer: "While based in Sri Lanka, CIAP serves the broader regional maritime market and is rapidly expanding its footprint to provide international maritime and industrial solutions globally."
        },
        {
            question: "Are CIAP's technicians certified to work on automated systems?",
            answer: "Absolutely. Our engineering team consists of highly skilled professionals experienced in diagnosing and resolving complex issues in sensors, actuators, communication networks, and various automation controllers used in modern vessels."
        },
        {
            question: "How can I request a technical assessment or a service quote?",
            answer: "You can easily request a quote through our 'Request a Quote' button on the website, or by contacting our technical department directly via email or our 24/7 live chat support."
        },
        {
            question: "Does CIAP provide industrial engineering solutions outside the marine sector?",
            answer: "Yes, CIAP leverages its marine engineering expertise to provide high-quality industrial services, including automation and mechanical maintenance for onshore facilities and power plants."
        },
        {
            question: "How does CIAP ensure the quality and safety of its repairs?",
            answer: "We adhere to strict international maritime standards and safety protocols. Our processes involve rigorous testing and quality control inspections to ensure every project meets the technical precision required for seaworthiness."
        }
    ];

    // Combine external data with internal expanded data
    const combinedQA = [...qaData, ...ciapSpecificQA];

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="faq-page-wrapper">
            <Navbar />

            {/* Hero Section */}
            <section className="faq-hero">
                <div className="faq-hero-overlay"></div>
                <img src={heroImg} alt="FAQ Hero" className="faq-hero-img" />
                <motion.div
                    className="faq-hero-content"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1>Frequently Asked Questions</h1>
                    <p>Everything you need to know about CIAP's marine and engineering solutions.</p>
                </motion.div>
            </section>

            {/* FAQ Accordion Section */}
            <section className="faq-content-section">
                <div className="faq-container">
                    <div className="faq-list">
                        {combinedQA.map((item, index) => (
                            <motion.div
                                key={index}
                                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.05 }}
                            >
                                <div
                                    className="faq-question-box"
                                    onClick={() => toggleAccordion(index)}
                                >
                                    <h3>{item.question}</h3>
                                    <span className="faq-icon">
                                        {activeIndex === index ? (
                                            <motion.span initial={{ rotate: 0 }} animate={{ rotate: 180 }}>−</motion.span>
                                        ) : (
                                            <motion.span initial={{ rotate: 180 }} animate={{ rotate: 0 }}>+</motion.span>
                                        )}
                                    </span>
                                </div>

                                <AnimatePresence>
                                    {activeIndex === index && (
                                        <motion.div
                                            className="faq-answer-box"
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3, ease: "easeInOut" }}
                                        >
                                            <div className="faq-answer-content">
                                                <p>{item.answer}</p>
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Support Section */}
            <section className="faq-support-section">
                <div className="faq-support-container">
                    <h2>Still have questions?</h2>
                    <p>Our team is ready to assist you with any technical inquiries or service requests.</p>
                    <div className="faq-support-btns">
                        <a href="/contact" className="faq-cta-btn primary">Contact Us</a>
                        <a href="/quotation" className="faq-cta-btn secondary">Request a Quote</a>
                    </div>
                </div>
            </section>

            <LiveChat />
            <QAChatbot />
            <GetQuoteButton />
            <ScrollSocialIcons />
            <BackToTopButton />
            <Footer />
        </div>
    );
};

export default Faq;